module.exports = __webpack_public_path__ + "img/icon-24-ic-remove.5ee7d7c8.svg";